import React from 'react'


const Checkbox = ({ onChange, name, object, children, readOnly = false, style }) => {
    return (
        <div className="react-form-checkbox" style={style}>
            <div className="checkbox-col">
                <input
                    type="checkbox"
                    checked={object[name] || false}
                    readOnly={readOnly}
                    disabled={readOnly}
                    onChange={(event) => {
                        if (readOnly) {
                            return
                        }
                        onChange(name, event.currentTarget.checked)
                    }}
                />
            </div><div className="label-col">
                {children}
            </div>
        </div>
    )
}


export default Checkbox



// WEBPACK FOOTER //
// ./src/modules/form/component/Checkbox.js